.language-switcher {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 40px;
  line-height: 16px;
  font-size: $font-size-base;
  color: var(--color-neutral-black);
  background: var(--color-neutral-white);
  border-radius: 4px;
  appearance: none;
  user-select: none;
  cursor: pointer;
  text-align: left;
  z-index: 39;
  overflow: visible;

  @include desktop-md {
    margin: 28px 0 0;
    height: 48px;
  }

  &::after {
    position: absolute;
    content: '';
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' fill='none' viewBox='0 0 8 5'%3E%3Cpath fill='%23414141' fill-rule='evenodd' d='M.293.293a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414 0l3-3A1 1 0 0 0 6.293.293L4 2.586 1.707.293a1 1 0 0 0-1.414 0' clip-rule='evenodd'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    width: 8px;
    height: 5px;
    right: 15px;
    transition: transform 0.2s;
    background-position: center;
    transform: translateY(-50%);
    transform-origin: center center;
    top: 50%;
  }

  .language-dropdown__list {
    display: block;
    margin: 0;
    padding: var(--spacing-xs) 0;
  }

  .language-dropdown__list-wrap {
    position: absolute;
    left: 0;
    right: 0;
    background: var(--background-color-primary);
    border: var(--border-size-sm) solid var(--border-color-secondary);
    border-radius: var(--radius-size-sm);
    box-shadow: 0 2px 4px rgb(47 55 62 / 15%);
    z-index: 3;
    max-height: 240px;
    overflow-y: auto;
    margin: 0;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transform: translateY(-10px);
    transition:
      opacity 0.2s ease,
      visibility 0s linear 0.2s,
      transform 0.2s ease;
    -webkit-overflow-scrolling: touch;
  }

  &.is-open {
    .language-switcher__label {
      outline: none;
      overflow: visible;
      box-shadow:
        0 0 0 var(--border-size-md) var(--color-neutral-white),
        0 0 0 var(--border-size-lg) var(--color-brand-primary-light);
    }

    &::after {
      transform: translateY(-50%) rotate(180deg);
    }

    .language-dropdown__list-wrap {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transition-delay: 0s;
      transform: translateY(0);
    }

    &.language-switcher--top {
      .language-dropdown__list-wrap {
        border-radius: var(--radius-size-sm) var(--radius-size-sm) 0 0;
        border-top: var(--border-size-sm) solid var(--border-color-secondary);
        border-bottom: none;

        // Position is set via inline styles in calculateDropdownPosition
      }
    }

    &.language-switcher--bottom {
      .language-dropdown__list-wrap {
        border-radius: 0 0 var(--radius-size-sm) var(--radius-size-sm);
        border-top: var(--border-size-sm) solid var(--border-color-secondary);
        border-bottom: none;

        // Position is set via inline styles in calculateDropdownPosition
      }
    }
  }

  .language-switcher__label {
    display: flex;
    padding-right: 50px;
    color: var(--color-neutral-black);
    white-space: nowrap;
    overflow: hidden;
    border: 1px solid var(--color-neutral-black);
    text-overflow: ellipsis;
    position: relative;
    border-radius: 4px;
    z-index: 2;
    height: 40px;
    align-items: center;
    max-width: 192px;
    flex-shrink: 0;
    left: -1px;
    font-size: $font-size-base;
    line-height: 24px;
    padding-left: 35px;
    transition: all 0.2s ease-in-out;

    @include desktop-md {
      font-size: 16px;
      line-height: 24px;
      height: 48px;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: none;
      overflow: visible;
      box-shadow:
        0 0 0 var(--border-size-md) var(--color-neutral-white),
        0 0 0 var(--border-size-lg) var(--color-brand-primary-light);
    }

    &::before {
      position: absolute;
      content: '';
      top: 0;
      bottom: 0;
      margin: auto;
      left: 11px;
      width: 18px;
      height: 18px;
      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' fill='none' viewBox='0 0 18 18'%3E%3Ccircle cx='9' cy='9' r='8' stroke='%23414141' stroke-width='1.5'/%3E%3Cellipse cx='9' cy='9' stroke='%23414141' stroke-width='1.5' rx='3.556' ry='8'/%3E%3Cpath stroke='%23414141' stroke-width='1.5' d='M1 11.805h15.111M1 6.472h15.111'/%3E%3C/svg%3E")
        no-repeat;
      background-size: contain;
    }
  }

  .language-dropdown__option {
    background: none;
    border: none;
    color: var(--text-color-primary);
    cursor: pointer;
    display: block;
    font-family: inherit;
    font-size: map-get($font-sizes, sm);
    font-weight: map-get($font-weights, normal);
    line-height: var(--spacing-md);
    margin: 0;
    overflow: hidden;
    padding: var(--spacing-sm) var(--spacing-md);
    position: relative;
    text-align: left;
    text-decoration: none;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;

    &:hover {
      background: var(--color-neutral-neutral-lighter);
      text-decoration: none;
    }

    &:focus {
      outline: none;
    }
  }

  .language-dropdown__option--active {
    color: var(--text-color-primary);
    font-weight: map-get($font-weights, semi-bold);
    position: relative;
  }

  .language-dropdown__option--focused {
    background: var(--color-neutral-neutral-lighter);
    outline: none;
  }
}
